import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { useState } from "react";
import { ListItemIcon, FormControl } from "@mui/material";

const MultiSelect = ({ options, selectedOptions, onChange, title }) => {
  const isAllSelected =
    options.length > 0 && selectedOptions.length === options.length;

  const handleChange = (event) => {
    const value = event.target.value;

    if (value[value.length - 1] === "all") {
      onChange(selectedOptions.length === options.length ? [] : options);
      return;
    }

    onChange(value);
  };

  return (
    <div className="dropdown-select">
      <div className="dropdown-select--title">{title}</div>
      <div className="dropdown-select--selector">
        <FormControl
          size={"small"}
          sx={{
            borderRadius: 0,
            display: "flex",
            boxShadow: "0px 4px 8px 0px #b4b4b9",
            "& .MuiOutlinedInput-notchedOutline": {
              borderWidth: 0,
            },
          }}
        >
          <Select
            labelId="select-label"
            multiple
            value={selectedOptions}
            onChange={handleChange}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={{
              style: {
                maxHeight: "300px",
              },
            }}
          >
            <MenuItem value="all">
              <ListItemIcon>
                <Checkbox
                  checked={isAllSelected}
                  indeterminate={
                    selectedOptions.length > 0 &&
                    selectedOptions.length < options.length
                  }
                />
              </ListItemIcon>
              <ListItemText primary="Select All" />
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                <ListItemIcon>
                  <Checkbox checked={selectedOptions.indexOf(option) > -1} />
                </ListItemIcon>
                <ListItemText>{option}</ListItemText>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

export default MultiSelect;
